<div
  class="d-flex align-items-center gap-3"
  [class.account-border-bottom]="!lastInList"
  [style.padding-top.rem]="0.75"
  [style.padding-bottom.rem]="lastInList ? 0 : 0.75">
  <div class="d-flex flex-column gap-2 flex-grow-1">
    <div class="account-name">{{ affectedAccount | submissionAffectedAccountDisplayName : accountType }}</div>
    <div class="account-id">{{ affectedAccount.accountId | leadingZero }}</div>
  </div>
  <button type="button" class="no-style-button" (click)="viewAccountClicked.emit()">
    <div class="d-flex gap-2 align-items-center">
      <div>
        <img
          src="assets/icons/primary/External%20Link.svg"
          alt=""
          height="18"
          width="18"
          [style.height.rem]="1.125"
          [style.width.rem]="1.125" />
      </div>
      <div class="view-account" i18n>View Account</div>
    </div>
  </button>
</div>
